<template>
  <div class="guide-container py-3">
    <div style="display: flex; justify-content: center; align-items: center;">
      <div class="title-form p-2">
        <span class="display-block">{{
          $t("help.lookupInfo")
        }}</span>
        <span class="display-block">{{
          $t("help.lookupOption1")
        }}</span>
        <span class="display-block">{{
          $t("help.lookupOption2")
        }}</span>
        <span>{{ $t("help.lookupOption3") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";
.title-form {
  color: $text-primary;
  font-size: 18px;
  font-weight: 700;
}
.guide-container {
  background-color: $bg-primary;
  border-radius: 1em;
}
</style>
